/**
 * Profile Completion Modal Component
 * Encourages users to complete their profiles
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, User, ChevronRight } from 'lucide-react';

/**
 * Profile Completion Modal Component
 * 
 * @param {Object} props - Component props
 * @param {Function} props.onClose - Function to close the modal
 * @returns {JSX.Element} Profile completion modal component
 */
const ProfileCompletionModal = ({ onClose }) => {
  const navigate = useNavigate();
  
  const handleNavigateToProfile = () => {
    navigate('/profile');
    onClose();
  };
  
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                <User className="h-6 w-6 text-green-600" />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                  Complete Your Profile
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Your profile is incomplete. Adding more information will help you connect with other students and get the most out of VarsityLink.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={handleNavigateToProfile}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 text-base font-medium text-white hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Complete Profile
              <ChevronRight className="ml-2 -mr-1 h-5 w-5" />
            </button>
            <button
              type="button"
              onClick={onClose}
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionModal;